import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllMoldItems,
  getProductItems,
  getAllVendorItems,
} from "../../store/AppLevelApi/AppLevelApi";
import ListComponent from "../Base/ListComponent";
import {
  FormOptionsProduction,
  FormOptionsProductionTable,
} from "../../ConstantData/ForDoubleInputField/ProductionFormData";
import { headTitle } from "../../utility/GetTableListName";
import {
  InitialFormProduction,
  InitialFormProductionTable,
} from "../../ConstantData/ForDoubleInputField/ProductionInputForm";
import CreateProduction from "./CreateProduction";
import Dropshadow from "../UIResuableComponents/Dropshadow";
const Production = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [tableData, setTableData] = useState(InitialFormProductionTable);
  const [formData, setData] = useState(InitialFormProduction);
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getProductItems("product"));
    // dispatch(getAllMoldItems());
    // dispatch(getAllVendorItems());
  }, []);
  const moldList = useSelector((state) => state.applevel.moldList);
  const productListAll = useSelector((state) => state.applevel.productList);
  const vendorListAll = useSelector((state) => state.applevel.vendorList);

  const onInputChangeHandlerTable = (e, index) => {
    const newTableData = { ...tableData };

    newTableData[e.target.name][index] = e.target.value;
    setTableData(tableData);
  };
  const onInputChangeHandler = (name, value, index) => {
    const newData = { ...formData };
    newData[name][index] = value;
    setData(newData);
  };
  const onClickClose = () => {
    setIsOpen(false);
  };
  const onClickOpen = () => {
    setIsOpen(true);
  };
  let newFormOptionsProduction = JSON.parse(
    JSON.stringify(FormOptionsProduction)
  );
  function addOptionForSelectField(FormOption, list, optionName) {
    newFormOptionsProduction = FormOption.map((item) => {
      if (item?.labelName === optionName) {
        item.options = list;
      }

      return item;
    });
  }
  if (moldList.length > 0) {
    //to chage subquality option coming from server
    addOptionForSelectField(newFormOptionsProduction, moldList, "Mold");
  }
  if (productListAll.length > 0) {
    //to chage subquality option coming from server
    addOptionForSelectField(
      newFormOptionsProduction,
      productListAll,
      "Product"
    );
  }
  if (vendorListAll.length > 0) {
    //to chage subquality option coming from server
    addOptionForSelectField(newFormOptionsProduction, vendorListAll, "Vendor");
  }

  const headTitleLabel = headTitle(
    [...newFormOptionsProduction, ...FormOptionsProductionTable],
    ["Product", "Mold", "Price"]
  ); //array is filed that is included in list heading

  return (
    <>
      <div>
        {isOpen && (
          <>
            <CreateProduction
              inputFormData={formData}
              FormOptionsProduction={newFormOptionsProduction}
              FormOptionsProductionTable={FormOptionsProductionTable}
              InitialFormProductionTable={tableData}
              CreateName={"create production"}
              FormStyle={"!w-[98%]  h-[100%]"}
              onInputChangeHandlerTable={onInputChangeHandlerTable}
              onInputChangeHandler={onInputChangeHandler}
              isOpen={isOpen}
              onClickClose={onClickClose}
            />
            <Dropshadow
              // onDropDownToggle={props.onChangeDropShadowHandler}
              dropDownStyle="z-20"
              // onCancelHandler={props.onCancelHandler}
              // createOrUpdate={props.createOrUpdate}
            />
          </>
        )}

        <ListComponent
          // setProducType={setProducType}
          // onEditHandler={onEditHandler}
          onChangeDropShadowHandler={onClickOpen}
          // onCancelHandler={onCancelHandler}
          // OptionName={"Factory"}

          OptionName={"Production"}
          generalList={[]}
          headTitle={headTitleLabel}
          // onDeleteHandler={onDeleteHandler}
          isNotDeleteBtn={false}
          OptionNameList={"Product"}
          // secondCreateBtn={props.secondCreateBtn}
          // needAdjust={props.needAdjust} //it is used if there is no edit but need adjust
          // setDataForAdjust={props.setDataForAdjust}
          // notShowEditBtn={props.notShowEditBtn}
        />
      </div>
    </>
  );
};

export default Production;
